import { IFeatureMenuQuery, useFeatureMenuQuery } from 'generated/sanity-graphql';
import { useFeaturesContext } from 'state/features';

interface IUseFeatureMenuValue {
  featureMenu: IFeatureMenuQuery['FeatureMenu'];
  featureMenuLoading: boolean;
}

export const useFeatureMenu = (): IUseFeatureMenuValue => {
  const { featureMenuId = '', featureIdsLoading } = useFeaturesContext();

  const { data, loading } = useFeatureMenuQuery({
    variables: { featureMenuId },
    skip: !featureMenuId
  });

  const featureMenu = data?.FeatureMenu ?? null;

  const featureMenuLoading = featureIdsLoading || loading;

  return {
    featureMenu,
    featureMenuLoading
  };
};
